import { beforeVisitGlobalMember } from "./beforeVisitGlobalMember.js";
import { traverseStoryboardExpressions } from "./traverse.js";
export function strictCollectMemberUsage(data, objectName) {
  let level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  const {
    hasNonStaticUsage,
    nonStaticUsage,
    usedProperties
  } = collectMemberUsage(data, objectName, level);
  if (hasNonStaticUsage) {
    throw new Error(`Non-static usage of ${objectName} is prohibited, check your expression: "${nonStaticUsage}"`);
  }
  return usedProperties;
}
export function collectMemberUsage(data, objectName) {
  let level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  const usage = {
    usedProperties: new Set(),
    hasNonStaticUsage: false
  };
  const beforeVisitGlobal = beforeVisitGlobalMember(usage, objectName, level);
  traverseStoryboardExpressions(data, (node, parent, expr) => {
    beforeVisitGlobal(node, parent);
    if (usage.hasNonStaticUsage) {
      usage.nonStaticUsage = expr;
    }
  }, objectName);
  return usage;
}
//# sourceMappingURL=collectMemberUsage.js.map